// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1R1fZ","ranges":"BmiRanges_ranges__nPsSc"};